
export const getHrRangeForType = (athlete, type) => {
  if (!athlete) return null;
  switch (type) {
    case 'easy':
      return athlete.easy_hr_cap_range;
    case 'long_run':
      return athlete.long_run_hr_range;
    case 'threshold':
      return athlete.threshold_hr_range;
    case 'race_pace_intervals':
      return athlete.race_pace_hr_range;
    case 'short_reps':
    case 'medium_intervals':
    case 'short_intervals':
    case 'long_intervals':
    case 'hills':
      return athlete.short_reps_hr_range;
    case 'race':
      return athlete.race_hr_range;
    default:
      return null;
  }
};